<!--
  系统配置（/setting）入口页
  子路由见 src/router/setting.js：site / artist_map / notify_setting / notify_dingtalk / region_list
-->
<template>
  <div>
    <router-view v-show='$route.matched.length==3'></router-view>
    <PageHeaderLayout v-show='$route.matched.length==2'>
      <div class='main-page-content'>
        <div class='setting-index'>
          <!-- 页面说明 -->
          <div class='setting-index__intro'>
            <div class='setting-index__title'>系统配置</div>
            <div class='setting-index__desc'>
              维护站点基础信息、红人对照、站内与钉钉消息模板等系统级配置；点击下方卡片进入对应配置页。
            </div>
          </div>

          <!-- 配置入口 -->
          <el-row :gutter='16'>
            <el-col :lg='8' :md='12' :sm='24' v-for='item in menus' :key='item.url'>
              <el-card shadow='hover' class='entry-card' @click.native='goToPage(item.url)'>
                <div class='entry-card__main'>
                  <div class='entry-card__icon' :style='{ color: item.color, background: item.background }'>
                    <i :class='item.icon'></i>
                  </div>
                  <div class='entry-card__content'>
                    <div class='entry-card__name'>{{ item.display_name }}</div>
                    <div class='entry-card__desc'>{{ item.description }}</div>
                  </div>
                  <i class='el-icon-arrow-right entry-card__arrow'></i>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

export default {
  name: 'SettingBase',
  components: {
    PageHeaderLayout
  },
  data() {
    return {
      // 系统配置入口（与 src/router/setting.js 的子路由保持一致）
      menus: [
        {
          icon: 'el-icon-setting',
          display_name: '站点配置',
          description: '站点名称、版权备案、LOGO、签约/刊例/选品规则及应用关联等站点信息',
          url: '/setting/site',
          color: '#5E7CE0',
          background: 'rgba(94, 124, 224, .1)'
        },
        {
          icon: 'el-icon-connection',
          display_name: '红人对照',
          description: '维护红人与系统账号的对照关系，用于数据归属与匹配',
          url: '/setting/artist_map',
          color: '#50D4AB',
          background: 'rgba(80, 212, 171, .12)'
        },
        {
          icon: 'el-icon-bell',
          display_name: '站内消息模板',
          description: '维护站内消息通知模板的内容、变量与启用状态',
          url: '/setting/notify_setting',
          color: '#6CBFFF',
          background: 'rgba(108, 191, 255, .12)'
        },
        {
          icon: 'el-icon-chat-dot-square',
          display_name: '钉钉消息',
          description: '维护钉钉消息推送配置及发送记录相关规则',
          url: '/setting/notify_dingtalk',
          color: '#FA9841',
          background: 'rgba(250, 152, 65, .12)'
        }
      ]
    }
  },
  methods: {
    goToPage(routeName) {
      this.$router.push({ path: routeName })
    }
  }
}
</script>

<style lang='scss' scoped>
.setting-index {
  padding: 16px 20px;
  box-sizing: border-box;

  &__intro {
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px dashed $--border-Lighter-color;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: $--color-text-primary;
  }

  &__desc {
    margin-top: 6px;
    font-size: 12px;
    line-height: 20px;
    color: $--color-text-secondary;
  }
}

.entry-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border-color: $--border-Lighter-color;
  cursor: pointer;
  transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: #ff3176;
    box-shadow: 0 6px 18px rgba(0, 0, 0, .1);

    .entry-card__arrow {
      color: #ff3176;
      transform: translateX(2px);
    }
  }

  ::v-deep .el-card__body {
    padding: 16px;
  }

  &__main {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  &__icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 10px;
    font-size: 20px;
  }

  &__content {
    flex-grow: 1;
    min-width: 0;
    margin-left: 12px;
  }

  &__name {
    font-size: 14px;
    font-weight: 600;
    color: $--color-text-primary;
  }

  &__desc {
    margin-top: 4px;
    font-size: 12px;
    line-height: 18px;
    color: $--color-text-secondary;
  }

  &__arrow {
    flex-shrink: 0;
    margin-left: 8px;
    color: $--color-text-Placeholder;
    transition: color .2s ease, transform .2s ease;
  }
}
</style>
